import React from 'react';
import { Box, Container, Typography, Paper, Divider } from '@mui/material';

const PrivacyPolicy = () => {
    return (
        <Container maxWidth="md" sx={{ py: { xs: 4, md: 8 } }}>
            <Paper
                elevation={6}
                sx={{
                    p: { xs: 3, md: 6 },
                    background: 'rgba(20, 20, 24, 0.95)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(139, 92, 246, 0.25)',
                    boxShadow: '0 20px 50px rgba(0, 0, 0, 0.8), 0 0 25px rgba(139, 92, 246, 0.15)',
                    borderRadius: 4,
                    color: '#fff',
                }}
            >
                <Typography
                    variant="h3"
                    component="h1"
                    gutterBottom
                    sx={{
                        fontFamily: 'Orbitron, sans-serif',
                        fontWeight: 700,
                        fontSize: { xs: '1.8rem', md: '2.4rem' },
                        background: 'linear-gradient(45deg, #FF0099, #8B5CF6, #00D4FF)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        mb: 3,
                    }}
                >
                    Política de Privacidade
                </Typography>

                <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.5)', display: 'block', mb: 3 }}>
                    Última atualização: Setembro de 2026 • Em conformidade com a LGPD
                </Typography>

                <Box sx={{ opacity: 0.95, lineHeight: 1.8, fontSize: '0.95rem' }}>
                    <Typography variant="body1" paragraph>
                        A sua privacidade é fundamental para nós. É política da <strong>NostalBeat</strong> (disponível em <a href="https://nostalbeat.com.br" style={{ color: '#00D4FF' }}>nostalbeat.com.br</a>) respeitar a sua privacidade e garantir a proteção de quaisquer dados pessoais que possam ser coletados em nossa plataforma de rádio web e interação comunitária.
                    </Typography>

                    <Typography variant="h5" gutterBottom sx={{ fontFamily: 'Orbitron', color: '#00D4FF', mt: 4 }}>
                        1. Dados Coletados e Finalidade
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Solicitamos informações pessoais apenas quando estritamente necessário para prestar nossos serviços e melhorar a sua experiência como ouvinte:
                    </Typography>
                    <Box component="ul" sx={{ pl: 3, mb: 2 }}>
                        <li>
                            <Typography variant="body2" sx={{ mb: 1 }}>
                                <strong>Navegação e Player de Rádio:</strong> O acesso ao streaming de áudio 24 horas não exige nenhum cadastro ou fornecimento de dados pessoais.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body2" sx={{ mb: 1 }}>
                                <strong>Autenticação via Google (Google Sign-In / OAuth 2.0):</strong> Ao optar por participar do mural de comentários utilizando sua conta Google, solicitamos apenas o escopo básico de identificação: <em>Nome de exibição, Endereço de e-mail e Foto de perfil pública</em>. Esses dados são utilizados exclusivamente para identificar suas mensagens no mural e exibir seu avatar.
                            </Typography>
                        </li>
                    </Box>

                    <Typography variant="h5" gutterBottom sx={{ fontFamily: 'Orbitron', color: '#8B5CF6', mt: 4 }}>
                        2. Uso e Compartilhamento de Informações
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Nós não vendemos, alugamos, comercializamos nem compartilhamos suas informações de identificação pessoal com terceiros, sob nenhuma circunstância, exceto quando expressamente exigido por lei ou determinação judicial competente.
                    </Typography>

                    <Typography variant="h5" gutterBottom sx={{ fontFamily: 'Orbitron', color: '#FF0099', mt: 4 }}>
                        3. Segurança e Retenção de Dados
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Retemos os dados coletados apenas pelo tempo necessário para cumprir as finalidades indicadas. Armazenamos e processamos os dados utilizando práticas de segurança e criptografia comercialmente aceitáveis para proteger contra perdas, roubos, acessos não autorizados, modificações ou divulgações indevidas.
                    </Typography>

                    <Typography variant="h5" gutterBottom sx={{ fontFamily: 'Orbitron', color: '#00D4FF', mt: 4 }}>
                        4. Cookies e Tecnologias de Publicidade (Google AdSense)
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Podemos utilizar provedores terceiros, como o Google AdSense, que utilizam cookies (como o cookie DoubleClick) para veicular anúncios de forma contextual ou personalizada de acordo com a sua navegação na Web, além de limitar a frequência com que determinados anúncios são exibidos. O usuário pode desativar o uso de cookies personalizados nas configurações de anúncios do Google.
                    </Typography>

                    <Typography variant="h5" gutterBottom sx={{ fontFamily: 'Orbitron', color: '#8B5CF6', mt: 4 }}>
                        5. Seus Direitos (LGPD) e Exclusão de Dados
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Em conformidade com a Lei Geral de Proteção de Dados (LGPD), você tem total direito de:
                    </Typography>
                    <Box component="ul" sx={{ pl: 3, mb: 2 }}>
                        <li><Typography variant="body2" sx={{ mb: 1 }}>Confirmar a existência de tratamento de dados e acessar as informações mantidas sobre você;</Typography></li>
                        <li><Typography variant="body2" sx={{ mb: 1 }}>Revogar a qualquer momento a autorização de login do Google pelo painel de segurança da sua conta Google;</Typography></li>
                        <li><Typography variant="body2" sx={{ mb: 1 }}>Solicitar a exclusão definitiva dos seus comentários e registros do nosso sistema entrando em contato com a equipe da rádio.</Typography></li>
                    </Box>

                    <Divider sx={{ my: 4, bgcolor: 'rgba(255,255,255,0.1)' }} />

                    <Typography variant="h5" gutterBottom sx={{ fontFamily: 'Orbitron', color: '#FF0099' }}>
                        6. Contato
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Caso tenha qualquer dúvida sobre esta Política de Privacidade ou sobre o tratamento de seus dados na NostalBeat, entre em contato conosco através do site oficial: <a href="https://nostalbeat.com.br" style={{ color: '#00D4FF' }}>https://nostalbeat.com.br</a>.
                    </Typography>
                </Box>
            </Paper>
        </Container>
    );
};

export default PrivacyPolicy;
